import {
  ConfiguracaoConciliacao,
  CreateConfiguracaoConciliacaoPayload,
  UpdateConfiguracaoConciliacaoPayload,
} from "@/models/conciliation-config.model";
import { axiosConsignadoInstance } from "@/services/axiosInstance";

const baseRoute = "/api-consignado-trabalhador/v1/configuracao-conciliacao";

export const createConfiguracaoConciliacao = async (
  payload: CreateConfiguracaoConciliacaoPayload
): Promise<ConfiguracaoConciliacao> => {
  const response = await axiosConsignadoInstance.post<ConfiguracaoConciliacao>(
    baseRoute,
    payload
  );

  return response.data;
};

export const listConfiguracoesConciliacao = async (): Promise<
  ConfiguracaoConciliacao[]
> => {
  const response = await axiosConsignadoInstance.get<ConfiguracaoConciliacao[]>(baseRoute);

  return response.data;
};

export const getConfiguracaoConciliacaoById = async (
  id: string
): Promise<ConfiguracaoConciliacao> => {
  const response = await axiosConsignadoInstance.get<ConfiguracaoConciliacao>(
    `${baseRoute}/${id}`
  );

  return response.data;
};

export const updateConfiguracaoConciliacao = async (
  id: string,
  payload: UpdateConfiguracaoConciliacaoPayload
): Promise<ConfiguracaoConciliacao> => {
  const response = await axiosConsignadoInstance.patch<ConfiguracaoConciliacao>(
    `${baseRoute}/${id}`,
    payload
  );

  return response.data;
};

export const deleteConfiguracaoConciliacao = async (id: string): Promise<void> => {
  await axiosConsignadoInstance.delete(`${baseRoute}/${id}`);
};
